<title>Register</title>
<app-banner [banner]="UserRegistrationThankyouPage.banner" [userName]="preferred_userName" [isDefaultPageBanner]="false" [isWelcomeUserBanner]="true"></app-banner>
<div class="container-fluid minHeight">
  <div id="rsView">
    <div class="container mt-2">
      <div class="pgcontent">
        <div class="row mt-5">
          <div class="col-sm-8">
            <h4>Thanks for updating the details.</h4>
            <h4>Please use the options above to access NDC communication hub or click <a class="login-link" href="profile">here</a> to manage your account.</h4>
          </div>
        </div>
      </div>
    </div>

    <input id="country" name="country" type="hidden" value="uk" />
    <input id="pgiid" name="pgiid" type="hidden" value="1331" />
  </div>
</div>
